import AppRoutes from './routes/AppRoutes';
import { ManagerProvider } from './features/dashboard/context/ManagerContext';
import { LoaderProvider } from './components/Loader/LoaderContext';

function App() {
  return (
    <LoaderProvider>
      <ManagerProvider>
        <AppRoutes />
      </ManagerProvider>
    </LoaderProvider>
  );
}

export default App;